var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"expandable",attrs:{"active":_vm.isActive}},[_c('div',{staticClass:"toggle",on:{"click":_vm.toggle}},[(!_vm.isActive)?_vm._t("triggerOn"):_vm._t("triggerOff")],2),_c('div',{staticClass:"content"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }